/** @format */

import {
	BottomPaginationComponent,
	ColorBreakoutComponent,
	CompareBarComponent,
	FilterChipsComponent,
	FilterComponent,
	NoFilteredResultsComponent,
	NotFoundComponent,
	PinnedContentComponent,
	PlpFeatureSpotComponent,
	ProductCardComponent,
	ProductListHeaderComponent,
	SeoContentComponent,
	ShippingOptionsComponent,
	SkeletonProductCardComponent,
	SortComponent,
	TopPaginationComponent
} from '@plp/components';
import {
	HmfButtonComponent,
	HmfCardComponent,
	HmfSidePanelComponent
} from '@dsg-tech/homefield-angular';
import {
	HomefieldGlobalChipsModule,
	HomefieldHeroBannerModule,
	HomefieldPriceModule,
	HomefieldProductImageModule,
	HomefieldStarRatingsComponent,
	HomefieldStrikethroughPriceModule,
	HomefieldTextLinkModule
} from '@homefield';
import { LoadingOverlayModule, ProTipsComponent, SnackbarModule } from '@shared/components';

import { CommonModule } from '@angular/common';
import { DynamicTemplateLoader } from '@shared/data-access/services';
// Had to import this way so that '@shared/favorites/components' doesn't eagerly load the ProductRecommendationsComponent;
import { FavoritesIconModule } from '../../../../../../../libs/shared/favorites/components/src/lib/favorites-icon/favorites-icon.module';
import { HomefieldIconLibraryModule } from '@dsg-tech/homefield-angular-icons';
import { IncludesPipe } from '@plp/utils';
import { MathFloorPipe } from '@shared/utils/pipes';

export const IMPORTS = [
	BottomPaginationComponent,
	ColorBreakoutComponent,
	CommonModule,
	CompareBarComponent,
	FavoritesIconModule,
	FilterComponent,
	FilterChipsComponent,
	HmfButtonComponent,
	HmfCardComponent,
	HmfSidePanelComponent,
	HomefieldGlobalChipsModule,
	HomefieldHeroBannerModule,
	HomefieldIconLibraryModule,
	HomefieldPriceModule,
	HomefieldProductImageModule,
	HomefieldStarRatingsComponent,
	HomefieldStrikethroughPriceModule,
	HomefieldTextLinkModule,
	IncludesPipe,
	LoadingOverlayModule,
	MathFloorPipe,
	NoFilteredResultsComponent,
	NotFoundComponent,
	PinnedContentComponent,
	PlpFeatureSpotComponent,
	ProTipsComponent,
	ProductCardComponent,
	ProductListHeaderComponent,
	SeoContentComponent,
	ShippingOptionsComponent,
	SkeletonProductCardComponent,
	SnackbarModule,
	SortComponent,
	TopPaginationComponent
];

export const PROVIDERS = [DynamicTemplateLoader];
